// 韓國
export default {
    dialog: {
        msgShow: "공고",
        buttonOk: '좋아요',
        buttonCancel: '취소',
    },
    photoBrowser: {
        bannerPhotoBrowser: '닫다'
    },
    employeeNumber: '기술자 ID',
    pleaseEnterEmployeeNumber: '기술자 ID 입력',
    password: '비밀번호',
    pleaseEnterPassword: '암호를 입력',
    login: '로그인',
    required: '필수의',
    synchronize: '동조.',
    salesOrder: '서비스 보고서',
    pleaseEnterHome: '고객 이름 및 서비스 보고서 입력',
    searchFilter: '검색 및 필터',
    machineSpecifications: '모델 및 사양',
    processingStatus: '정세',
    processing: '진행중',
    finish: '완전한',
    waitCountermeasures: null,
    reset: '반품',
    submit: '전송된',
    muMachineInvestigation: '기계 활용',
    logout: '로그 아웃',
    searchDate: '검색 날짜',
    time: '검색 시간',
    basicInformation: '고객 데이터',
    addSalesOrder: '서비스 보고서 추가',
    save: '구하다',
    date: '날짜',
    pleaseSelectDate: '날짜 선택',
    travelNumber: '서비스 보고서 파일',
    pleaseEnterTravelNumber: '서비스 보고서 파일 번호를 입력하세요.',
    customerCode: '고객 코드',
    pleaseEnterCustomerCode: '고객 코드를 입력하세요',
    customerName: '고객 이름',
    pleaseEnterCustomerName: '고객 이름을 입력하세요',
    country: '국가 지역',
    pleaseEnterCountry: '국가 지역을 입력하세요',
    customerAddress: '고객 주소',
    pleaseEnterAddress: '고객 주소 입력',
    customerContact: '고객 담당자',
    pleaseEnterContact: '고객 담당자 입력',
    salesRepresentative: '영업 담당자',
    pleaseEnterSalesRepresentative: '영업 담당자를 입력해주세요',
    hint: '공고',
    createDate: '확정일자',
    salesOrderNumber: '보고서 파일 번호',
    customerSatisfaction: '고객 만족',
    maintenancePersonnel: '기술자',
    maintenanceTime: '서비스 시간',
    customerConfirmation: '고객 확인',
    copy: '복사',
    delete: '삭제',
    recordTime: null,
    machineNumber: '기계번호',
    copyToSalesOrder: '복사',
    copyTo: '에게 복사',
    selectSalesOrderNumber: '서비스 보고서 파일 선택',
    pleaseEnterSalesOrderNumber: '서비스 보고서 파일 번호를 입력하세요.',
    latitudeAndLongitude: '위도 경도',
    startMaintenance: '서비스 시작',
    endMaintenance: '서비스 종료',
    newMachine: '설치신고',
    maintenance: '기계 수리',
    addMachineServiceOrder: null,
    selectType: '유형 선택',
    generalMaintenance: '기계 수리',
    oilEducationTraining: '오일 교육',
    pleaseEnterMachineNumber: '기계번호를 입력하세요.',
    manufacturingDate: '제조일자',
    pleaseSelectManufacturingDate: '제조일자 선택',
    maintenanceWarranty: '보증 서비스(1년)',
    underWarranty: '보증 기간 내 서비스',
    warrantyExpired: '보증 만료',
    confirm: '좋아요',
    cancel: '취소',
    addMaintenancePersonnel: '추가 기술자 이름을 입력하세요.',
    maintenanceTimeTotal: '총 서비스 시간',
    day: '날',
    hour: '시간',
    enterFactory: '서비스 시작',
    pleaseSelectEnterFactory: '서비스 시작 선택',
    longitude: '경도',
    // pleaseEnterLongitude: '위도를 입력하세요',
    latitude: '위도',
    // pleaseEnterLatitude: '경도를 입력하세요',
    leaveFactory: '서비스 종료',
    pleaseSelectLeaveFactory: '마무리 서비스를 선택해 주세요',
    duration: '서비스 시간',
    pleaseEnter: '입장해주세요',
    selectTime: '날짜 및 시간 선택 선택',
    selectSatisfaction: '고객 만족',
    verySatisfied: '매우 만족',
    satisfied: '만족하는',
    ordinary: '평범한',
    dissatisfied: '불만',
    veryDissatisfied: '매우 불만',
    opinionReply: '고객의 의견',
    takePhoto: '사진을 찍다',
    uploadFile: '파일 업로드',
    audio: '오디오 파일',
    video: '비디오 파일',
    electronicSignature: '고객의 서명',
    signatureDate: '서명 날짜',
    clear: '삭제',
    machineInformation: '머신 데이터',
    machineFunction: '기계 점검',
    organizationArrangement: '구조 및 패턴',
    spareParts: '부속',
    operationProcedure: '테스트 기록',
    problemHandling: '프로세스',
    trainee: '연습생',
    coursePlan: '코스 계획',
    courseSchedule: '코스 일정',
    inputVoltageAndCurrent: '전압/암페어 입력',
    lowSpeed: '느린 속도',
    highSpeed: '고속',
    accelerationDecelerationSlope: '12월/가을 비탈길',
    acceleration: 'Acc. 비탈길',
    deceleration: '12월 램프',
    clothRoller: '차지하다',
    left: '왼쪽',
    center: '가운데',
    right: '오른쪽',
    yarnFeedingTeeth: '고품질 기어/풀리',
    saddleRingDistance: '거리 캠 홀더 링 및 프레임',
    yarnNozzleNumber: '원사 캐리어',
    height: '키',
    spacing: '갭',
    warpYarnInfo: '회색 직물',
    inch: '신장',
    cm: '센티미터',
    timeSequence: '타이밍',
    needle: '바늘',
    yarnSpecification: '원사 사양',
    yarn: '실',
    serialNumber: '기타 기계 번호',
    technician: '기술자',
    series: '패브릭 시리즈',
    fabricType: '원단 종류',
    productFeatures: '제품 특징',
    inputVoltage: '전압을 입력하세요',
    inputCurrent: '암페어를 입력하세요',
    electronicWindingTensionUpper: '전기 롤러 암페어(상단)',
    electronicWindingTensionLower: '전기 롤러 암페어(낮음)',
    mechanicalType: '기계화. 롤러 기어',
    lowerNeedleDistanceToSeatRing: '디스. 실린더 및 캠 홀더 링',
    upperNeedleDistanceToSeatRing: '디스. 다이얼 및 캠 홀더 링',
    upperNeedleDistanceToLowerNeedleNozzle: '갭 다이얼 및 실린더 노크 오버 엣지',
    selectorNeedleRingDistanceToTakeUpPlate: '디스. 액추에이터 링과 프레임 사이',
    seatRingDistanceToTakeUpPlate: '디스. 캠 홀더 링과 프레임 사이',
    machineSpeed: 'RPM',
    inverterFrequency: '인버터 HZ',
    yarnCount: 'CPI',
    gramsPerSquareMeter: 'GSM',
    yardsPerPound: 'G/YD',
    customerYarnWidth: '너비',
    customerSpecifiedYarnLength: '스티치 길이 지정',
    newCustomerPackageTiming: '싱커 타이밍',
    doubleSidedCuttingTiming: '다이얼 캠 타이밍',
    nozzleTiming: '원사 캐리어 타이밍',
    yarnCode: '원사 코드',
    yarnType: '원사 사양',
    color: '색상',
    yarnSize: '원사 수',
    fiberCount: '필라멘트',
    innerFiber: '쌓아두다',
    outerFiber: '쌓아올리다',
    flatness: '수평성',
    roundness: '진원도',
    windPressure: '공기압',
    appearance: '모습',
    machineLevel: '기계 프레임 수평도',
    trident: '다이얼의 수평도 및 진원도',
    highLegWinder: '하이 레그 테이크업',
    fabricSlitting: '열린 너비 차지',
    inverterCurrent: '인버터 암페어',
    machineFunctionFrame: '원사 MPF 및 링 및 크릴',
    inchStart: '조그, 시작 및 정지 스위치 기능.',
    firstSecondSpeed: '속도, 램프 및 팬 스위치 기능.',
    firstSecondSpeed2: '속도 설정 기능',
    controllerOtherFunctions: '기타 기능 컨트롤러의',
    electricalBoxSignals: '신호 및 센서',
    fanDustRemovalAction: '팬 작동',
    oilSprayerAction: '오일러 작동',
    airBlowerSystemAction: '공기압 및 작동',
    windingAction: '시스템을 채택하십시오. 작업',
    machineControllerOperationTutorial: '제어판 조작 교육',
    machineOperationTutorial: 'M/C 운용 교육',
    other: '기타',
    descriptionAndAttachment: '참조',
    upperNeedleArrangement: '다이얼 바늘 주문',
    upperKnifeArrangement: '다이얼 칼 주문',
    lowerNeedleArrangement: '실린더 바늘 주문',
    lowerNeedleArrangementShort: '실린더 바늘 주문',
    lowerKnifeArrangement: '실린더 칼 주문',
    lowerKnifeArrangementShort: '실린더 칼 주문',
    upperNeedlePlate: '다이얼',
    lowerNeedleCylinder: '실린더',
    blank: '공간',
    blockRule: '지그 측정',
    retractionBaseline: '싱커 간격 뒤쪽에',
    upperPlateNeedleWithdrawalKnob: '다이얼 스케일 손잡이',
    upperPlateNeedleWithdrawalDepth: '다이얼 스티치 간격',
    upperPlateHalfNeedleHeight: '다이얼 니트, 터크 캠 간격',
    upperPlateFlatNeedleHeight: '다이얼 미스캠 간격.',
    lowerCylinderFlatNeedleHeight: '실린더 미스 캠 간격',
    lowerCylinderFlatNeedleDepth: '실린더 스티치 간격',
    lowerCylinderNeedleWithdrawalKnob: '실린더 스케일 손잡이',
    yarnTypeCode: '원사 코드',
    yarnTypeTensionN: '원사 장력(N)',
    cmPer100Needles: '스티치 길이 / 100침',
    feedYarnLengthPerRevolution: '땀길이 / 1코스',
    aluminumPlateYarnFeedingDepthCm: '품질 풀리 직경. (센티미터)',
    yarnFeedingAluminumPlateScale: '품질 풀리 마크',
    newCustomerPackage: '싱커',
    upperPlate: '다이얼',
    lowerCylinder: '실린더',
    yarnShort: '원사',
    pleaseEnterProductName: '부품 특성 입력',
    pleaseEnterProductNumber: '부품번호 입력',
    quantity: '수량',
    damage: '고장',
    missing: '없어진',
    wrong: '잘못된',
    pleaseEnterTitle: '제목 입력',
    pleaseEnterContent: '내용 입력',
    addQuestionItem: '질문 항목 추가',
    questionProcessingRecord: '대책기록',
    pleaseEnterQuestionDescription: '문제 설명 입력',
    traineeAndClient: '작업 / 고객',
    trainer: '작업자',
    drawingFunction: 'CAD 기능',
    upperMachineProgram: '기계 프로그램',
    UnravelingFunction: '원단 분석',
    courseName: '코스명',
    pleaseEnterCourseName: '코스명 입력',
    imageName: '패턴 파일 이름',
    pleaseEnterImageName: '패턴 파일 이름 입력',
    confirmItem: '확인',
    undone: '불완전한',
    pleaseEnterInquire: '고객 이름, MU 문서 입력',
    machineUtilizationSurvey: '기계 활용',
    customerID: '고객 ID',
    pleaseEnterCustomerID: '고객 ID를 입력하세요',
    pleaseSelect: '선택',
    pleaseEnterSkill: '스킬 입력',
    pleaseEnterBuyer: '구매자 입력',
    pleaseEnterRemark: '참조',
    source: '원천',
    selfInput: '自行輸入',
    textileEquipment: '편직기',
    textileMachineBrand: '편직기 브랜드',
    textileMachineType: '편직기 모델',
    notSelected: null,
    select: '선택',
    brand: '브랜드',
    totalMachine: null,
    openRate: null,
    dailyOutput: null,
    spinning: '紡紗',
    knitting: '針織',
    dyeing: '染整',
    garment: '成衣',
    pleaseEnterProcessingContent: '조정 내용을 입력.',
    // alert
    editNotSave: '수정사항이 저장되지 않았다. 정말 나가시겠어요?',
    deleteConfirm: '삭제하시겠습니까?',
    confirmClearSignature: '서명 관련 데이터를 삭제하시겠습니까?',
    confirmWriteData: '데이터를 쓰시겠습니까?',
    confirmCopyToSalesOrder: '이 서비스 보고서에 데이터를 복사하시겠습니까?',
    fieldsNotFilledUnableToSend: '尚有欄位未填寫，無法送出。',
    dataWriteComplete: '資料寫入完成。',
    deleteSuccess: '삭제에 성공.',
    clearSuccess: '제거에 성공.',
    copySuccess: '복사가 완료.',
    selectWorker: '기술자 이름',
    selectProblem: '질문 내용',
    unknownError: 'An unknown error has occurred, please contact customer service.',
    fileTypeError: 'File type mismatch',
    openCameraPermission: 'Please grant camera access first.',
    //new
    selectDate: '날짜 선택',
    yarnTensionN: '원사 장력(N)',
    category: '유형',
    kind: '모델',
    // pleaseSelectType: '유형 선택',
    dateInOutError: '서비스 날짜는 서비스 시작일이나 이후로 설정',
    yarnFeedingTeethOrDisc: '고품질 기어/풀리',
    changed: '변경됨',
    pleaseSelectSparePartsStatus: '부속 상태',
    pleaseEnterDuration: null,

    // API語系
    saveComplete: '저장완료。',
    needOnline: 'Need Online.',
    addComplete: '추가되었음。',
    reportCreator: '보고서 작성자',
    onlineGenerate: ' Generate after uploading',
    synchronizeFail: 'Synchronize Fail',
    synchronizeSuccess: '동기화 완료',
    downloadFail: 'Download Fail',
    downloadSuccess: '다운로드 완료',
    synchronizeSelect: '동시 선택',
    onlySynchronizeOffData: '다운로드',
    synchronizeData: '오프라인 데이터 동기화 중',
    synchronizeImage: '이미지 동기화',
    downloadOfflineFile: 'Download OffLine File',
    downloadOfflineData: '오프라인 데이터 다운로드',
    downloadOfflineImage: '오프라인 이미지 다운로드',
    synchronizing: '동기화 중, 대기, 지금 화면 유지',
    downloading: '다운로드 중, 기다려 주세요. 지금 화면 유지',
    confirmDownload: '다운로드 확인？',
    confirmSynchronization: '동기화 확인？',
    overwriteOffline : '다운로드하면 현재 오프라인 데이터를 덮어 씀',
    synchronizationOnline: '온라인 데이터 동기화',
    uploadFail: 'Upload failed.',
    fileSzieOverTit: 'The file size is too large.',
    fileSzieOverMes: 'Only files under 50 MB can be uploaded. For files over 50 MB, please upload to the wired version.',

    sortByCreate: '생산 순서',
    sortByType: '디자인 정리',
    reportDownload: '보고서',
    selectServiceReport: '서비스 보고서 선택',
    enterServiceReportOrMachine: '서비스 보고서 번호 또는 기계 번호를 입력하십시오',
    selectAll: '모두 선택',

    downloadHint:null
}
